<template>
  <div class="prbg-white prrounded prborder p-3 ">
    <div class="col-12 col-md-12 " style="width: 100%;">
      <div class="card-header">
        <ul class="nav nav-tabs card-header-tabs" role="tablist" style="flex-wrap:nowrap !important">
          <li class="nav-item w-50">
            <a class="nav-link w-100" @click="flagFlag('one')" style="width: max-content;" aria-controls="first" aria-selected="true">تراکنش ها</a>
          </li>
          <li class="nav-item w-50">
            <a class="nav-link w-100" @click="flagFlag('two')" style="width: max-content;" aria-controls="two" aria-selected="true">درخواست برداشت ها</a>
          </li>
        </ul>
      </div>
      <div class="card-body">
        <div class="tab-content">
          <div class="tab-pane fade overflow-auto" :class="{ 'active show': flag.one }" id="first" role="tabpanel" aria-labelledby="first-tab">
            <div class="alert alert-warning my-1 border-0 prfont-weight text-center w-100" role="alert">مجموع تراکنش های شما {{ convertToPersian(String(sumTransaction)) }} تومان است.</div>
            <div class="float-md-right d-flex align-items-center w-50 my-2">
              <span class="text-muted text-small">نمایش</span>
              <select class="form-control rounded" v-model="tranType" @change="getTransaction">
                <option value="all">همه</option>
                <option v-for="item,index in transactionTypes" :key="index" :value="item">{{ item }}</option>
              </select>
            </div>
            <table class="mt-2 table table-hover table-bordered table-striped" id="orderTable">
              <thead>
                <tr>
                  <th scope="col">شماره تراکنش</th>
                  <th scope="col">نوع تراکنش</th>
                  <th scope="col">تاریخ</th>
                  <th scope="col">مبلغ کل (تومان)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in transactionList" :key="item.id" :data-id="item.id">
                  <td>{{ convertToPersian(String(item.id)) }}</td>
                  <td>{{ item.type }}</td>
                  <td>{{ item.date }}</td>
                  <td>{{ convertToPersian(String(item.amount)) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="tab-pane fade overflow-auto" :class="{ 'active show': flag.two }" id="two" role="tabpanel" aria-labelledby="two-tab">
            <table class="mt-2 table table-hover table-bordered table-striped" id="orderTable">
              <thead>
                <tr>
                  <th scope="col">شماره استرداد</th>
                  <th scope="col">تاریخ</th>
                  <th scope="col">وضعیت</th>
                  <th scope="col">مبلغ کل (تومان)</th>
                  <th scope="col">توضیحات</th>
                  <th scope="col">رسید</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in refundList" :key="item.id" :data-id="item.id">
                  <td>{{ convertToPersian(String(item.id)) }}</td>
                  <td>{{ item.date }}</td>
                  <td>{{ item.state == 1 ? 'در حال بررسی' : 2 ? 'تایید شده' : 'رد شده' }}</td>
                  <td>{{ convertToPersian(String(item.amount)) }}</td>
                  <td><span v-if="item.code">کد پیگیری : {{convertToPersian(String(item.code))}}</span><br v-if="item.code" /> {{ item.description }}</td>
                  <td>
                    <a v-if="item.file" :href="'https://radap.ir/'+item.file" target="_blank" class="text-dark"><i class="fa fa-eye" ></i></a>
                    <i v-else class="fa fa-close"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from "@vue/reactivity";
import { convertToPersian } from "@/composables/digits";
import { useAuth } from '@/store/auth'
let auth = useAuth()
let transactionList = ref();
let tranType = ref('all');
let transactionTypes = ref();
let sumTransaction = ref('');
let refundList = ref();
let flag = reactive({
  one: true,
  two: false
})
auth.getToken()
getTransaction();
getRefundTransaction();
async function getTransaction() {
  let response = await fetch('https://radap.ir/Backend/api/account/transaction/get.php?userId=' + auth.profile.id + '&type=2'+"&transaction="+tranType.value)
  let data = await response.json()
    transactionList.value = data.data;
    transactionTypes.value = data.types;
    sumTransaction.value = data.sum;
}
async function getRefundTransaction() {
  let response = await fetch('https://radap.ir/Backend/api/account/transaction/refund.php?userId=' + auth.profile.id)
  let data = await response.json()
      refundList.value = data.data;
}
function flagFlag(num) {
  // function flagFlag(e,num){
  flag.one = false
  flag.two = false
  if (num == 'one') {
    flag.one = true
  } else {
    flag.two = true
  }
}
</script>

<style scoped>
/* @import "../../../../assets/css/account.css"; */

table thead tr th {
  text-align: right;
}
</style>